import React from 'react';
import { StyleSheet } from 'react-native';
import TouchableOpacity from 'utils/packages/TouchableOpacity';
import useColors from 'hooks/useColors';
import IconClose from './icons/IconClose';
import { hitSlop } from './values';
import { isWeb } from '../constants';
const NavigationCloseButton = ({ onPress, colorKey = 'primary', color, testID, onPressIn, onPressOut, inWebHeader, }) => {
    const colors = useColors();
    return (<TouchableOpacity testID={testID} hoverOnDark onPress={onPress} hitSlop={hitSlop} onPressIn={onPressIn} onPressOut={onPressOut} style={inWebHeader && isWeb ? styles.webHeader : undefined}>
      <IconClose alt color={color ?? colors.elements[colorKey]}/>
    </TouchableOpacity>);
};
// Same spacing as the web BackButton
const styles = StyleSheet.create({
    webHeader: {
        padding: 8,
        borderRadius: 10,
        marginLeft: 16,
    },
});
export default NavigationCloseButton;
